import { makeCygnusApiCall } from "../../../../../api/api";

/**
 * Adds a new client group.
 *
 * @param groupName - Name of the new group
 */
export const addGroup = async (groupName: string): Promise<void> => {
  await makeCygnusApiCall({
    type: "POST",
    url: "/client_groups/",
    payload: {
      GroupName: groupName,
      GroupType: "Default",
      GroupTypeCode:"",
      Active: "Y",
    },
    customized_success_message: "Group added successfully.",
    customized_failure_message: "Failed to add group. Please try again.",
    customized_error_message: "Error while adding group.",
    forMDM: true,
    isblob: false,
    show_message: true,
  });
};

/**
 * Updates the name of an existing client group.
 *
 * @param groupId - ID of the group to update
 * @param newName - New name to set
 */
export const updateGroup = async (groupId: number, newName: string): Promise<void> => {
  await makeCygnusApiCall({
    type: "PUT",
    url: `/client_groups/`,
    payload: {
      ClientGroupId: groupId,
      GroupName: newName,
      GroupTypeCode:""
    },
    customized_success_message: "Group name updated successfully.",
    customized_failure_message: "Failed to update group. Please try again.",
    customized_error_message: "Error while updating group name.",
    forMDM: true,
    isblob: false,
    show_message: true,
  });
};

/**
 * Soft-deletes a client group by setting Active = 'N'.
 *
 * @param groupId - ID of the group to delete
 */
export const deleteGroup = async (groupId: number): Promise<void> => {
  await makeCygnusApiCall({
    type: "PUT",
    url: `/client_groups/${groupId}/`,
    payload: {
      Active: "N",
    },
    customized_success_message: "Group deleted successfully.",
    customized_failure_message: "Failed to delete group. Please try again.",
    customized_error_message: "Error while deleting group.",
    forMDM: true,
    isblob: false,
    show_message: true,
  });
};
